/* Ordinary Mile Club - Product Card Image Fix
 * Flora theme slideshow custom elements prevent product images from rendering.
 * This replaces the slideshow with direct img elements + correct z-index.
 */
(function() {
  function fixProductCardImages() {
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function(card) {
      var gallery = card.querySelector('[class*="card-gallery"]');
      if (!gallery) return;
      if (gallery.getAttribute('data-omc-fixed')) return;
      
      var slideshowImg = gallery.querySelector('slideshow-slide img');
      if (!slideshowImg) return;
      
      gallery.setAttribute('data-omc-fixed', 'true');
      
      var imgSrc = slideshowImg.getAttribute('src') || '';
      var imgSrcset = slideshowImg.getAttribute('srcset') || '';
      var imgSizes = slideshowImg.getAttribute('sizes') || '';
      var imgAlt = slideshowImg.getAttribute('alt') || '';
      var imgWidth = slideshowImg.getAttribute('width') || '';
      var imgHeight = slideshowImg.getAttribute('height') || '';
      var imgLoading = slideshowImg.getAttribute('loading') || 'lazy';
      
      var link = gallery.querySelector('a');
      var linkHref = link ? link.getAttribute('href') : '';
      
      if (link) link.remove();
      
      var newLink = document.createElement('a');
      newLink.href = linkHref;
      newLink.style.cssText = 'display:block!important;width:100%!important;height:100%!important;position:relative!important;z-index:9999!important;';
      
      var newImg = document.createElement('img');
      newImg.src = imgSrc;
      if (imgSrcset) newImg.srcset = imgSrcset;
      if (imgSizes) newImg.sizes = imgSizes;
      newImg.alt = imgAlt;
      if (imgWidth) newImg.width = imgWidth;
      if (imgHeight) newImg.height = imgHeight;
      newImg.loading = imgLoading;
      newImg.style.cssText = 'width:100%!important;height:100%!important;object-fit:contain!important;display:block!important;position:relative!important;z-index:9999!important;';
      newImg.className = 'product-media__image omc-fixed-img';
      
      newLink.appendChild(newImg);
      gallery.insertBefore(newLink, gallery.firstChild);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductCardImages);
  } else {
    fixProductCardImages();
  }
  
  setTimeout(fixProductCardImages, 500);
  setTimeout(fixProductCardImages, 1500);
  setTimeout(fixProductCardImages, 3000);
  
  var observer = new MutationObserver(function(mutations) {
    var shouldFix = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length) shouldFix = true;
    });
    if (shouldFix) setTimeout(fixProductCardImages, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();